import { render, staticRenderFns } from "./secTitle.vue?vue&type=template&id=174f02ec&scoped=true&"
import script from "./secTitle.vue?vue&type=script&lang=js&"
export * from "./secTitle.vue?vue&type=script&lang=js&"
import style0 from "./secTitle.vue?vue&type=style&index=0&id=174f02ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174f02ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('174f02ec')) {
      api.createRecord('174f02ec', component.options)
    } else {
      api.reload('174f02ec', component.options)
    }
    module.hot.accept("./secTitle.vue?vue&type=template&id=174f02ec&scoped=true&", function () {
      api.rerender('174f02ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/secTitle.vue"
export default component.exports